<template>
	<v-list-item>
		<v-list-item-content>
			<v-list-item-title v-html="title"> </v-list-item-title>
			<v-list-item-subtitle v-html="subtitle"></v-list-item-subtitle>
		</v-list-item-content>
		<v-list-item-action-text>
			<v-row>
				<v-col v-if="firebase">
					<v-checkbox
						multiple
						v-model="item"
						value="fcm"
						:label="$t('label.firebase')"
					></v-checkbox>
				</v-col>
				<v-col v-if="mail">
					<v-checkbox
						multiple
						v-model="item"
						value="mail"
						:label="$t('label.mail')"
					></v-checkbox>
				</v-col>
				<v-col v-if="database">
					<v-checkbox
						multiple
						v-model="item"
						value="database"
						:label="$t('label.database')"
					></v-checkbox>
				</v-col>
				<v-col v-if="broadcast">
					<v-checkbox
						multiple
						v-model="item"
						value="broadcast"
						:label="$t('label.broadcast')"
					></v-checkbox>
				</v-col>
			</v-row>
		</v-list-item-action-text>
	</v-list-item>
</template>

<script>
export default {
	props: {
		value: {
			required: true,
		},
		title: {
			type: String,
			required: false,
			default: null,
		},
		subtitle: {
			type: String,
			required: false,
			default: null,
		},
		mail: {
			type: Boolean,
			required: false,
			default: true,
		},
		database: {
			type: Boolean,
			required: false,
			default: true,
		},
		broadcast: {
			type: Boolean,
			required: false,
			default: true,
		},
		firebase: {
			type: Boolean,
			required: false,
			default: false,
		},
	},

	computed: {
		item: {
			get() {
				return this.value;
			},
			set(value) {
				this.$emit("input", value);
			},
		},
	},
};
</script>